// @ts-nocheck
import React from 'react';
import AuthSigninView from './view';
import AuthSigninProvider from './state';
import PtlSignup from '../ptlSignup';
import { ErrorBoundary } from 'ErrorBoundary';
import * as Sentry from "@sentry/browser";
import { initGlobalCachePrevention } from '../utils/preventBrowserCache';

interface IAuthSigninProps {
}

try {
    Sentry.init({
        enabled: APP_CONFIG?.sentry?.enabled,
        dsn: APP_CONFIG?.sentry.dsn,
        environment: APP_CONFIG?.sentry?.env,
        debug: !IS_PROD,
        release: APP_VERSION,
        sampleRate: APP_CONFIG?.sentry?.sampleRate,
        tracesSampleRate: APP_CONFIG?.sentry?.tracesSampleRate,
        maxBreadcrumbs: 10
    });

    const trackerProperties = window.trackerProperties;
    if (trackerProperties && trackerProperties.analyticsId) {
        Sentry.setUser({
            id: trackerProperties.analyticsId,
        }); // this is being set by web repo code

        Sentry.setExtras({
            userId: trackerProperties?.guestId,
            time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            created_at: trackerProperties?.createdAt,
            path: window.location.href
        })
    }
} catch (e) {
    console.error(e);
}

const AuthSignin: React.FC<IAuthSigninProps> = () => (
    <ErrorBoundary>
        <AuthSigninProvider>
            <AuthSigninView />
        </AuthSigninProvider>
    </ErrorBoundary>
)

// Initialize global cache prevention
initGlobalCachePrevention();

const container = document.getElementById('auth-signin-container-wrap');

if (container) {
    import('react-dom/client').then(({ createRoot }) => {
        const root = createRoot(container);
        root.render(<AuthSignin />);
    })
}

export default AuthSignin;